import React, { useState, useEffect } from 'react';
import styles from './SchedulingFlow.module.css';
import plusIcon from './SVGs/plus.svg';
import userIcon from './SVGs/user.svg';
import AxisLogo from './SVGs/AxisLogo';


const LandingStep: React.FC<{ onSelect: (type: 'new' | 'existing') => void }> = ({ onSelect }) => {
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 700);
    };
    
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);

  const NAV_PHONE = '(720) 400-7025';

  const handleLogoClick = () => {
    // Redirect to Axis website
    window.open('https://www.axismh.com/', '_blank');
  };

  return (
    <div className={styles.landingRoot}>
      {/* Top Banner with Background Image and Overlay */}
      <div className={styles.topBanner}>
        <img src={require('./SVGs/image001.png')} alt="Banner" className={styles.bannerImg} />
        <div className={styles.bannerOverlay} />
        {/* Nav Bar */}
        <div className={styles.navBar}>
          <AxisLogo variant="white" size="extra-large" className={styles.navLogo} onClick={handleLogoClick} style={{ cursor: 'pointer' }} />
          <span className={styles.navPhone}>{NAV_PHONE}</span>
        </div>
        <div className={styles.bannerContent}>
          <h1 className={styles.bannerTitle}>Book Online</h1>
          <div className={styles.bannerSubtitle}>
            Schedule your mental health appointment with our qualified providers. Choose between telehealth or in-person visits.
          </div>
        </div>
      </div>

      {/* Main Content Section */}
      <div className={styles.landingMain}>
        <div className={styles.landingHeader}>
          <h2 className={styles.landingTitle}>How would you like to Proceed?</h2>
          <div className={styles.landingSubtitle}>Choose the option that best fits your needs</div>
        </div>
        <div className={styles.landingCards}>
          <div className={styles.landingCard} onClick={() => onSelect('new')}>
            <div className={styles.cardIconCircle}>
              <img src={plusIcon} alt="New Patient" className={styles.cardIcon} />
            </div>
            <div className={styles.cardTitle}>New Appointment</div>
            <div className={styles.cardDesc}>Schedule your first appointment with our mental health providers</div>
            <button className={styles.cardBtnFilled}>Book New Appointment</button>
          </div>
          <div className={styles.landingCard} onClick={() => onSelect('existing')}>
            <div className={styles.cardIconCircle}>
              <img src={userIcon} alt="Existing Patient" className={styles.cardIcon} />
            </div>
            <div className={styles.cardTitle}>Existing Appointment</div>
            <div className={styles.cardDesc}>Reschedule or cancel your existing appointment with our mental health providers</div>
            <button className={styles.cardBtnOutline}>Manage Appointment</button>
          </div>
        </div>
      </div>

      {/* Footer Placeholder */}
      <footer className={styles.landingFooter}>
        <div className={styles.footerContent}>
          <div className={styles.footerTitle}>Axis Integrated Mental Health</div>
          <div className={styles.footerRating}>
            <span className={styles.footerStars}>★★★★★</span>
            <span className={styles.footerAvg}>Average Rating: 4.9/5</span>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LandingStep; 